// extracted by mini-css-extract-plugin
module.exports = {"customTag":"custom-tag_customTag__gig7t","red":"custom-tag_red__2WzlS"};